import React, { useState, useEffect } from "react";
import { login, fetchBalance, checkAddressExists, saveWallet } from "../../api";
import { initData } from "@telegram-apps/sdk";
import { useTonConnectUI, useTonWallet } from "@tonconnect/ui-react";

import "./Welcome.css";

const Welcome = ({}) => {
  const [error, setError] = useState("");
  const [notStarted, setNotStarted] = useState(null);
  // const [wConnected, setWConnected] = useState(null);

  const errorWrapper = (e) => {
    setError(e);
  };

  const onConnected = () => {
    fetchBalance(
      (b) => {
        const queryParams = new URLSearchParams(window.location.search);
        const inviteGameId = queryParams.get("tgWebAppStartParam", "");
        if (inviteGameId) {
          window.location.href = `/join/${inviteGameId}`;
        } else {
          window.location.href = `/menu`;
        }
      },
      (_) => {}
    );
  };

  const checkLogin = () => {
    const onError = (message) => {
      console.log("MSG", message);
      if (message == null || message == "400") {
        errorWrapper("Oops, something went wrong.");
        return;
      }
      if (message == "404") {
        setNotStarted(true);
        return;
      }
    };
    const onLogin = async (data) => {
      setNotStarted(false);
      localStorage.setItem("token", data.access_token);
      localStorage.setItem("wallet_connected", data.wallet_connected);
      localStorage.setItem("tokenTimestamp", Date.now() + 23 * 60 * 60 * 1000);
      localStorage.setItem("user_id", userId);
      onConnected();
      // checkAddressExists(setWConnected, errorWrapper);
    };
    const userId = initData.user().id;
    console.log("initData", initData.raw());
    login(userId, initData.raw(), onLogin, onError);
  };

  useEffect(() => {
    checkLogin();
  }, []);

  // useEffect(() => {
  //   if (wConnected) {
  //     onConnected();
  //   }
  // }, [wConnected]);

  return (
    <div>
      {error && <p className="error">{error}</p>}
      {notStarted == true && <NotStartedView checkLogin={checkLogin} />}
      {/* {wConnected == false && (
        <ConnectWalletView setWConnected={setWConnected} />
      )} */}
      {notStarted == null && <LoadingView />}
    </div>
  );
};

const LoadingView = ({}) => {
  return (
    <div className="loading-view">
      <img className="large-svg" src={"dice_logo.svg"} />
      <div className="development-text">Loading...</div>
    </div>
  );
};

const NotStartedView = ({ checkLogin }) => {
  useEffect(() => {
    const intervalId = setInterval(checkLogin, 5000);
    return () => clearInterval(intervalId);
  }, []);

  return (
    <div className="first-screen-view">
      <div className="welcome-text-title">👋 Hello!</div>
      <div className="welcome-text">
        To start playing, please activate the bot
      </div>
      <a href="https://t.me/secretdice_bot/start" className="action-button">
        Activate
      </a>
    </div>
  );
};

// const ConnectWalletView = ({ setWConnected }) => {
//   const [error, setError] = useState("");
//   const [tonConnectUi] = useTonConnectUI();
// const wallet = useTonWallet();

// useEffect(() => {
//   if (wallet?.account?.address) {
//     console.log(wallet.appName);
//     console.log(wallet.account?.address);
//     saveWallet(
//       wallet.account?.address,
//       wallet.appName,
//       setWConnected,
//       setError
//     );
//   }
// }, [wallet, tonConnectUi]);

//   return (
//     <div className="first-screen-view">
//       <div className="welcome-text-title">🎲 Cool!</div>
//       <div className="welcome-text">Please connect your wallet</div>
//       <div className="welcome-text-subtitle">
//         We will not be able to withdraw any funds without owner confirmation
//       </div>
//       {error && <p className="error">{error}</p>}
//       <button
//         onClick={() => tonConnectUi.openModal()}
//         className="action-button"
//       >
//         Connect
//       </button>
//     </div>
//   );
// };

export default Welcome;
